import React, { useState } from 'react';
 import { ChevronDown } from "lucide-react";
import COLORS from '../../../constants/colors.js';

const faqData = [
  {
    question: 'Which baby food brands are involved?',
    answer:
      'Investigations have listed brands like Gerber, Beech-Nut, Earth\'s Best, HappyBABY, and more.',
  },
  {
    question: 'Is there a scientific link to autism?',
    answer:
      'Heavy metals such as arsenic and lead are known to harm brain development. Studies and legal reviews suggest a link between early exposure and autism diagnoses.',
  },
  {
    question: 'Do I need to prove which brand my child consumed?',
    answer:
      'Proof of purchase helps but is not always required. Intake teams will help assess this.',
  },
  {
    question: 'What age range qualifies?',
    answer:
      'Typically, children diagnosed before age 12, with early exposure to packaged baby foods, may qualify.',
  },
  {
    question: 'Is this a class action?',
    answer:
      'Most cases are filed as individual mass tort claims. You may be eligible for compensation specific to your child\'s harm.',
  },
];



const BabyFoodEight = () => {
  const [activeIndex, setActiveIndex] = useState(null); // No dropdown open by default

  const toggle = (idx) => {
    setActiveIndex(idx === activeIndex ? null : idx);
  };

  return (
    <section className="py-12 px-2 sm:px-4 md:px-8 lg:px-16 w-full max-w-none" style={{ fontFamily: 'Quicksand, sans-serif' }}>
      {/* Title */}
      <h2
        className="text-[32px] sm:text-[40px] font-semibold mb-6 capitalize leading-none"
        style={{ color: COLORS.darkBlueAlt }}
      >
        Frequently Asked{' '}
        <span style={{ color: COLORS.yellow, fontWeight: 'semibold' }} className="capitalize">
          Questions
        </span>
      </h2>

      {/* Accordion */}
      <div className="space-y-4">
        {faqData.map((item, idx) => (
          <div key={idx} className="border border-gray-200 rounded overflow-hidden">
            <button
              onClick={() => toggle(idx)}
              className={`w-full text-left px-4 py-3 flex justify-between items-center transition`}
              style={{ 
                fontFamily: 'Quicksand, sans-serif',
                backgroundColor: activeIndex === idx ? COLORS.lightBlueAlt : COLORS.white
              }}
            >
              <span className="text-[20px] sm:text-[24px] font-semibold leading-normal"
                    style={{ color: COLORS.darkBlueAlt }}>
                {item.question}
              </span>
             <span className="text-[18px] font-light select-none">
                <ChevronDown
                  className={`w-5 h-5 transform transition-transform duration-300`}
                  style={{ 
                    color: activeIndex === idx ? COLORS.yellow : COLORS.darkBlueAlt,
                    transform: activeIndex === idx ? 'rotate(180deg)' : 'rotate(0deg)'
                  }}
                />
              </span>
            </button>
            {activeIndex === idx && (
              <div className="px-4 pb-4 pt-1 text-[18px] sm:text-[20px] font-medium leading-normal"
                   style={{ 
                     fontFamily: 'Quicksand, sans-serif',
                     color: COLORS.gray,
                     backgroundColor: COLORS.lightBlueAlt
                   }}>
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default BabyFoodEight;
